import { Role } from 'types/gql-generated';

export const userGroups = [Role.MT_SUPER_ADMIN_OWNER, Role.MT_ADMIN];
export const departments = [Role.MT_SUPER_ADMIN_OWNER, Role.MT_ADMIN];
export const projectRoles = [Role.MT_SUPER_ADMIN_OWNER, Role.MT_ADMIN];
export const expenseCategories = [Role.MT_SUPER_ADMIN_OWNER, Role.MT_ADMIN, Role.MT_FINANCE];
